import apiClient from 'services/axios'
import ApiConfig from 'services/config'

const { SubscriptionConfig } = ApiConfig

export async function loadSubscription() {
  return apiClient
    .get(SubscriptionConfig.LOAD_SUBSCRIPTION)
    .then(response => {
      if (response) {
        return response.data
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function loadProducts() {
  return apiClient
    .get(SubscriptionConfig.LOAD_PRODUCTS)
    .then(response => {
      if (response) {
        return response.data
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function loadShopifyProducts() {
  return apiClient
    .get(SubscriptionConfig.LOAD_PRODUCTS_SHOPIFY)
    .then(response => {
      if (response) {
        return response.data
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function loadInvoices() {
  return apiClient
    .get(SubscriptionConfig.LOAD_INVOICES)
    .then(response => {
      if (response) {
        return response.data
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function updateSubscription(products, payment_method_id) {
  return apiClient
    .put(SubscriptionConfig.UPDATE_SUBSCRIPTION, { products, payment_method_id })
    .then(response => {
      if (response) {
        return response.data
      }
      return false
    })
}
